export default __webpack_public_path__ + "static/media/placeholder_shop.39c7d737.svg";